// extracted by mini-css-extract-plugin
module.exports =  {"hedy-title":"Source15-N4CQ__hedy-title"};